import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useAppSelector } from '../../../reducers';
import { planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { filteredProductConfigurationsForShoppingCartTBOnlySelector, shouldIncludeLineItemTBSelector, skuIdIsOrHasHubSelector } from '../../../selectors/ProductsSelectors';
import CoreSeatsPickerForPlanBuilder from '../CoreSeatsPickerForPlanBuilder';
import ShoppingCartItem from './ShoppingCartItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      children: children
    })
  });
};
const ShoppingCartContainer = ({
  allowRemoveCartItems = true
}) => {
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const selectedAnyHubs = useAppSelector(state => {
    return productConfigurations.some(productConfiguration => skuIdIsOrHasHubSelector(state, {
      skuId: productConfiguration.skuId
    }));
  });
  const {
    paidCoreSeatProductConfigs,
    paidSalesServiceSeatProductConfigs,
    hubProductConfigs,
    nonSuiteProductConfigs
  } = useAppSelector(state => {
    return filteredProductConfigurationsForShoppingCartTBOnlySelector(state, {
      productConfigurations
    });
  });
  const [filteredNonSuiteProductConfigs, filteredPaidCoreSeatProductConfigs, filteredHubProductConfigs, filteredPaidSalesServiceSeatProductConfigs] = useAppSelector(state => [nonSuiteProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config))), paidCoreSeatProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config))), hubProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config))), paidSalesServiceSeatProductConfigs.filter(config => shouldIncludeLineItemTBSelector(state, Object.assign({}, config)))]);
  const [filteredNonSuiteSkuIds, filteredPaidCoreSeatSkuIds, filteredHubSkuIds, filteredPaidSalesServiceSeatSkuIds] = [filteredNonSuiteProductConfigs.map(({
    skuId
  }) => skuId), filteredPaidCoreSeatProductConfigs.map(({
    skuId
  }) => skuId), filteredHubProductConfigs.map(({
    skuId
  }) => skuId), filteredPaidSalesServiceSeatProductConfigs.map(({
    skuId
  }) => skuId)];
  const showPaidCoreSeats = filteredPaidCoreSeatSkuIds.length > 0 || selectedAnyHubs;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(HeaderContainer, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.shoppingCart.yourProducts"
      })
    }), filteredHubSkuIds.map(skuId => /*#__PURE__*/_jsx(ShoppingCartItem, {
      skuId: skuId,
      isCloseable: allowRemoveCartItems
    }, skuId)), showPaidCoreSeats && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeaderContainer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'planBuilder.shoppingCart.yourSeats'
        })
      }), /*#__PURE__*/_jsx(View, {
        "data-selenium-class": "shopping-cart-item-container",
        paddingBlock: "400",
        paddingInline: "600",
        position: "relative",
        backgroundColor: "fill-surface-raised",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(CoreSeatsPickerForPlanBuilder, {})
      }), filteredPaidSalesServiceSeatSkuIds.map(skuId => /*#__PURE__*/_jsx(ShoppingCartItem, {
        skuId: skuId,
        isCloseable: allowRemoveCartItems
      }, skuId))]
    }), filteredNonSuiteSkuIds && !!filteredNonSuiteSkuIds.length && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeaderContainer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.shoppingCart.addOnsAndServices"
        })
      }), filteredNonSuiteSkuIds.map(skuId => /*#__PURE__*/_jsx(ShoppingCartItem, {
        skuId: skuId,
        isCloseable: allowRemoveCartItems
      }, skuId))]
    })]
  });
};
export default ShoppingCartContainer;